import React from 'react';
import { markdownToHtml } from './slideTextRenderer';

export const stripHtmlForHighlight = (text) => {
    if (typeof text !== 'string') return String(text || '');
    return text
        .replace(/<br\s*\/?>/gi, ' ')          // Replace <br> with space
        .replace(/<[^>]+>/g, '')               // Remove all HTML tags
        .replace(/&nbsp;/gi, ' ')              // Replace &nbsp; with space
        .replace(/\s+/g, ' ')                  // Collapse multiple spaces
        .trim();
};

export const highlightWordRenderer = (id, rawText, currentWordIndex = -1, speechPartRanges = {}) => {
    if (!rawText) return null;

    // Normalize rawText → string
    const normalized =
        typeof rawText === 'string'
            ? rawText
            : Array.isArray(rawText)
                ? rawText.flatMap(v =>
                    typeof v === 'string'
                        ? v
                        : v && typeof v === 'object'
                            ? Object.values(v).filter(x => typeof x === 'string')
                            : []
                ).join(' ')
                : typeof rawText === 'object'
                    ? Object.values(rawText).filter(v => typeof v === 'string').join(' ')
                    : String(rawText);

    if (!normalized.trim()) return null;

    // Plain text may carry markdown (**bold**, _italic_, "- " bullet
    // lines). Real HTML content above already forfeits TTS
    // word-highlighting in favor of dangerouslySetInnerHTML, so do the
    // same once markdown is converted to tags — otherwise this prints the
    // raw markers literally and bullet lines run together inline (e.g.
    // activity instructions showing "**Success criteria:** - Selects...").
    const withInlineTags = markdownToHtml(normalized);
    const hasHtml = /<[^>]+>/.test(withInlineTags);
    const plainText = stripHtmlForHighlight(withInlineTags);
    const words = plainText.split(' ');

    const range = speechPartRanges?.[id];
    if (!range) {
        return hasHtml ? <span dangerouslySetInnerHTML={{ __html: withInlineTags }} /> : words.map((w, i) => <span key={i}>{w + ' '}</span>);
    }

    const localIndex = currentWordIndex - range.start;
    if (localIndex < 0 || localIndex >= words.length) {
        return hasHtml ? <span dangerouslySetInnerHTML={{ __html: withInlineTags }} /> : words.map((w, i) => <span key={i}>{w + ' '}</span>);
    }

    const highlightStyle = 'background-color:#FFF3CD;color:#000;border-radius:4px;';

    // HTML case
    if (hasHtml) {
        let wordCounter = 0;

        const highlighted = withInlineTags.replace(/(<[^>]+>)|([^\s<]+)/g, (match, tag, word) => {
            if (tag) return tag;
            const shouldHighlight = wordCounter === localIndex;
            wordCounter++;
            return shouldHighlight
                ? `<span style="${highlightStyle}">${word}</span>`
                : word;
        });
        return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
    }

    // Plain text case
    return words.map((w, i) => (
        <span
            key={`${id}-w-${i}`}
            style={i === localIndex ? {
                backgroundColor: '#FFF3CD',
                color: '#000',
                borderRadius: '4px'
            } : {}}
        >
            {w + ' '}
        </span>
    ));
};
